// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Rm7e","importantInfo":"styles_importantInfo__2b_sV"};